import React from 'react'
import { Skeleton } from '@material-ui/lab'
import { TableCell, TableRow } from '@material-ui/core'

const LoaderTableView = ({ rowsNum }) => {
  let count = 0
  return [...Array(rowsNum)].map(() => (
    <TableRow key={`loader-${count++}`}>
      <TableCell component="th" scope="row" style={{ width: '25vw' }}>
        <Skeleton animation="wave" variant="text" style={{ width: '25vw' }} />
      </TableCell>
      <TableCell style={{ width: '10vw' }}>
        <Skeleton animation="wave" variant="text" />
      </TableCell>
      <TableCell style={{ width: '20vw' }}>
        <Skeleton animation="wave" variant="text" />
      </TableCell>
      <TableCell style={{ width: '15vw' }}>
        <Skeleton animation="wave" variant="text" />
      </TableCell>
      <TableCell style={{ width: '30vw' }}>
        <Skeleton animation="wave" variant="text" />
      </TableCell>
    </TableRow>
  ))
}

export default LoaderTableView
